var r = { exports: {} };
export {
  r as i
};
//# sourceMappingURL=isBuffer.js.map
